<ng-template #bulkmodal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h3>Bulk Upload</h3>
        <p class="text-right">
            <i class="fa fa-close" aria-hidden="true" style="cursor:pointer" (click)="close()"></i>
        </p>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-12">
                <div class="card-body pt-2">
                    <div class="row">
                        <div class="col-md-12 text-right pull-right" style="padding-top: 25px">
                            <div (click)="downloadExcel()" style="cursor: pointer"> Download Sample Excel <i class="fa fa-download" aria-hidden="true" style="color:#329688"></i></div>
                        </div>

                        <div class="custom-file" style="margin-top: 19px;">
                            <input #fileUploader type="file" class="custom-file-input" id="inputGroupFile02"
                                   aria-describedby="inputGroupFileAddon01" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" name="file" (click)="fileUploader.value = null" (change)="readUrl($event)">
                            <label *ngIf="filetype == ''" class="custom-file-label">Upload Excel</label>
                            <label *ngIf="filetype != ''" class="custom-file-label">{{filetype[0]}}.{{filetype[1]}}</label>
                        </div>
                        <div class="mt-3">
                            <span style="color: firebrick">*</span><small>Note: Upload format should be same as Sample Excel Format</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="btn-popup pull-right">
            <button class="btn btn-primary" (click)="onUploadFinished('upload')">Submit</button>
        </div>
    </div>
</ng-template>
<ng-template #emailmodal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h3>Email  Invite</h3>
        <p class="text-right">
            <i class="fa fa-close" aria-hidden="true" style="cursor:pointer" (click)="close()"></i>
        </p>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <div class="modal-body">
                    <tag-input [(ngModel)]='teacherBlukEmail'
                               name="teacherBlukEmail"
                               #email="ngModel"
                               [errorMessages]="errorMessages"
                               [validators]="validators"
                               [editable]='true'
                               [separatorKeyCodes]="[32,188,186,13,9]"
                               [placeholder]="'Add email'"
                               [secondaryPlaceholder]="'Enter email address'"
                               [clearOnBlur]="true"
                               [addOnPaste]="true"
                               [addOnBlur]="true"
                               theme='bootstrap'
                               required >
                    </tag-input>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" (click)="emailInviteUpload('email')">Submit</button>
    </div>
</ng-template>
<div class="container-fluid px-0" *ngIf="schoolStatus.length != 0">
    <div class="card pt-1">
        <div class="card-header">
            <h5>Teacher Details</h5>
        </div>
        <div class="card-body">
            <div class="row my-4">
                <div class="col-12">
                    <a class="btn btn-primary pull-right ml-3" (click)="this.auth.setSessionData('UsersRedirection', 'Teacher')" [routerLink]="'/Teacher/create-Teacher/add'">Add Teacher</a>
                    <div class="dropdown pull-right">
                        <button class="btn btn-outline-primary">Invite <i class="fa fa-sort-desc float-right ml-2" aria-hidden="true"></i></button>
                        <div class="dropdown-content" style="right: 1px">
                            <a class="cursor" (click)="bulkModal()"> Bulk Upload</a>
                            <a class="cursor" (click)="emailModal()"> Invite By Email</a>
                        </div>
                    </div>
                </div>
            </div>
            <div id="batchDelete" class="category-table custom-datatable transcation-datatable user-image">
                <div class="table-responsive">
                    <app-table [TableType]="'Teacher'" [TableArray]="listData" (clickValue)="emittedValue($event)"></app-table>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="schoolStatus.length == 0">
    <app-emptyschool>
    </app-emptyschool>
</div>
<!-- Container-fluid Ends-->
<ng-template #content1 let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title col-12 text-center"><b>Reset Password Using E-Mail</b></h4>
    </div>
    <div class="modal-body">
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <h5 class="text-center mt-3">Are you sure want to reset password for {{resetPassword.first_name}}</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn cancel" (click)="close()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="change(1)">Confirm</button>
    </div>
</ng-template>
<ng-template #contentnow let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title col-12 text-center"><b>Reset Password Now</b></h4>
    </div>
    <div class="modal-body">
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <form [formGroup]="ntPassword">
                <div class="row form-group auth-form">
                    <input required="" readonly class="form-control" type="text" placeholder="Email" formControlName="email">
                    <em class="error" *ngIf="!ntPassword.get('email').valid && (ntPassword.get('email').dirty || ntPassword.get('email').touched)">Email is required</em>
                </div>
                <div class="row form-group auth-form">
                    <div class="input-group">
                        <input required="" type="text" formControlName="password"
                               class="form-control" placeholder="Password" aria-label="Recipient's username" aria-describedby="basic-addon1" [type]="conps ? 'password' : 'text'">
                        <div class="input-group-append">
                                     <span class="input-group-text" id="basic-addon3">
                                            <i [class]="conps ? 'fa fa-eye-slash' : 'fa fa-eye'" style="color: #7F3486" aria-hidden="true" (click)="conps = !conps"></i>
                                     </span>
                        </div>
                    </div>
                    <em class="error" *ngIf="ntPassword.get('password').hasError('required') && (ntPassword.get('password').dirty || ntPassword.get('password').touched)">Password is required</em>
                    <em *ngIf="ntPassword.get('password').hasError('minlength')" class="error help-block">Minimum 5 characters required</em>
                </div>
                <div class="row form-group auth-form">
                    <div class="input-group">
                        <input required="" type="text" formControlName="confirmpassword"
                               class="form-control" placeholder="Confirm Password" aria-label="Recipient's username" aria-describedby="basic-addon1" [type]="conps1 ? 'password' : 'text'">
                        <div class="input-group-append">
                           <span class="input-group-text" id="basic-addon2">
                               <i [class]="conps1 ? 'fa fa-eye-slash' : 'fa fa-eye'" style="color: #7F3486" aria-hidden="true" (click)="conps1 = !conps1"></i>
                           </span>
                        </div>
                    </div>
                    <em class="error" *ngIf="ntPassword.get('confirmpassword').hasError('required') && (ntPassword.get('confirmpassword').dirty || ntPassword.get('confirmpassword').touched)">Confirm Password is required</em>
                    <div *ngIf="checkPasswords()">
                        <em class="error help-block">
                            Enter same password as above
                        </em>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn cancel" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="change(2)">Confirm</button>
    </div>
</ng-template>

<ng-template #viewdetails let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Teacher details</h4>
        <i class="fa fa-close fa-lg mt-1" aria-hidden="true"
           style="color:#7F3486; cursor: pointer; float: right;" (click)="close()"></i>
    </div>
    <div class="modal-body">
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card-body pt-2">
                        <div class="row d-flex flex-column">
                            <div class="mb-5 fit-image">
                                <img *ngIf="(viewdetail.profile_url == '' || viewdetail.profile_url == null) && viewdetail.gender.toLowerCase() == 'male'"
                                     src="assets/images/ristaschool/male.png" alt="">
                                <img *ngIf="(viewdetail.profile_url == '' || viewdetail.profile_url == null) && viewdetail.gender.toLowerCase() == 'female'"
                                     src="assets/images/ristaschool/female1.png" alt="">
                                <img *ngIf="(viewdetail.profile_url == '' || viewdetail.profile_url == null) && (viewdetail.gender.toLowerCase() == 'n/a'|| viewdetail.gender == '')"
                                     src="assets/images/ristaschool/Do not want to disclose.png" alt="">
                                <img *ngIf="viewdetail.profile_url != ''" class="card-img-top img-thumbnail"
                                     [src]="sanitizer.bypassSecurityTrustResourceUrl(webhost + '/' + viewdetail.profile_url)"
                                     alt="">
                            </div>
                            <table class="capital">
                                <tr>
                                    <td class="pl-4"><b>Status:</b></td>
                                    <td class="badge badge-success" *ngIf="viewdetail.status == 'Active'">
                                        Active
                                    </td>
                                    <span class="badge  badge-danger" *ngIf="viewdetail.status == 'Inactive'">In-Active</span>
                                    <span class="badge badge-warning" *ngIf="viewdetail.status  == 'Suspended'">Suspended</span>
                                    <span class="badge badge-danger" *ngIf="viewdetail.status  == 'Deleted'">In-Active</span>
                                </tr>
                                <tr>
                                    <td class="pl-4"><b>Contact Number:</b></td>
                                    <td>{{viewdetail.mobile}}</td>
                                </tr>
                                <tr>
                                    <td class="pl-4" style="width: 150px"><b>Address:</b></td>
                                    <td *ngIf="viewdetail.address1 != '' && viewdetail.address1 != null">{{viewdetail.address1}}</td>
                                </tr>
                                <tr *ngIf="viewdetail.address2 != ''">
                                    <td></td>
                                    <td>{{viewdetail.address2}}</td>
                                </tr>
                                <tr *ngIf="viewdetail.city != '' && viewdetail.city != null && viewdetail.state_name != ''">
                                    <td></td>
                                    <td>{{viewdetail.city}}<br>
                                        {{viewdetail.state_name}}<br>
                                        {{viewdetail.country_name}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Container-fluid Ends-->

    </div>
    <div class="modal-footer">
        <button type="button" class="btn cancel" (click)="close()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="editAction(viewdetail)">Edit</button>
    </div>
</ng-template>
